var map = {
	"./card_100_wins_1.mp3": 38509,
	"./card_10_wins_1.mp3": 20295,
	"./card_11_wins_1.mp3": 51896,
	"./card_12_wins_1.mp3": 9541,
	"./card_13_wins_1.mp3": 81662,
	"./card_14_wins_1.mp3": 97475,
	"./card_15_wins_1.mp3": 85876,
	"./card_16_wins_1.mp3": 81089,
	"./card_17_wins_1.mp3": 34666,
	"./card_18_wins_1.mp3": 26223,
	"./card_19_wins_1.mp3": 6112,
	"./card_1_wins_1.mp3": 13493,
	"./card_20_wins_1.mp3": 10724,
	"./card_21_wins_1.mp3": 97299,
	"./card_22_wins_1.mp3": 64698,
	"./card_23_wins_1.mp3": 70129,
	"./card_24_wins_1.mp3": 94248,
	"./card_25_wins_1.mp3": 66295,
	"./card_26_wins_1.mp3": 10670,
	"./card_27_wins_1.mp3": 72181,
	"./card_28_wins_1.mp3": 22508,
	"./card_29_wins_1.mp3": 75259,
	"./card_2_wins_1.mp3": 18600,
	"./card_30_wins_1.mp3": 20797,
	"./card_31_wins_1.mp3": 78902,
	"./card_32_wins_1.mp3": 68447,
	"./card_33_wins_1.mp3": 54928,
	"./card_34_wins_1.mp3": 14041,
	"./card_35_wins_1.mp3": 66850,
	"./card_36_wins_1.mp3": 49499,
	"./card_37_wins_1.mp3": 12044,
	"./card_38_wins_1.mp3": 72085,
	"./card_39_wins_1.mp3": 29870,
	"./card_3_wins_1.mp3": 47127,
	"./card_40_wins_1.mp3": 92434,
	"./card_41_wins_1.mp3": 86601,
	"./card_42_wins_1.mp3": 66300,
	"./card_43_wins_1.mp3": 72395,
	"./card_44_wins_1.mp3": 3782,
	"./card_45_wins_1.mp3": 18221,
	"./card_46_wins_1.mp3": 55872,
	"./card_47_wins_1.mp3": 55151,
	"./card_48_wins_1.mp3": 53162,
	"./card_49_wins_1.mp3": 67425,
	"./card_4_wins_1.mp3": 41626,
	"./card_50_wins_1.mp3": 10651,
	"./card_51_wins_1.mp3": 10700,
	"./card_52_wins_1.mp3": 98201,
	"./card_53_wins_1.mp3": 46434,
	"./card_54_wins_1.mp3": 86559,
	"./card_55_wins_1.mp3": 20816,
	"./card_56_wins_1.mp3": 74173,
	"./card_57_wins_1.mp3": 73206,
	"./card_58_wins_1.mp3": 42835,
	"./card_59_wins_1.mp3": 38244,
	"./card_5_wins_1.mp3": 54641,
	"./card_60_wins_1.mp3": 90744,
	"./card_61_wins_1.mp3": 69127,
	"./card_62_wins_1.mp3": 94078,
	"./card_63_wins_1.mp3": 60101,
	"./card_64_wins_1.mp3": 32212,
	"./card_65_wins_1.mp3": 96035,
	"./card_66_wins_1.mp3": 20330,
	"./card_67_wins_1.mp3": 76225,
	"./card_68_wins_1.mp3": 25824,
	"./card_69_wins_1.mp3": 53007,
	"./card_6_wins_1.mp3": 77540,
	"./card_70_wins_1.mp3": 6897,
	"./card_71_wins_1.mp3": 83290,
	"./card_72_wins_1.mp3": 93939,
	"./card_73_wins_1.mp3": 99236,
	"./card_74_wins_1.mp3": 47445,
	"./card_75_wins_1.mp3": 20238,
	"./card_76_wins_1.mp3": 34423,
	"./card_77_wins_1.mp3": 81384,
	"./card_78_wins_1.mp3": 92761,
	"./card_79_wins_1.mp3": 87490,
	"./card_7_wins_1.mp3": 82131,
	"./card_80_wins_1.mp3": 72230,
	"./card_81_wins_1.mp3": 50669,
	"./card_82_wins_1.mp3": 25664,
	"./card_83_wins_1.mp3": 69199,
	"./card_84_wins_1.mp3": 33106,
	"./card_85_wins_1.mp3": 20905,
	"./card_86_wins_1.mp3": 87260,
	"./card_87_wins_1.mp3": 95211,
	"./card_88_wins_1.mp3": 10270,
	"./card_89_wins_1.mp3": 59941,
	"./card_8_wins_1.mp3": 12502,
	"./card_90_wins_1.mp3": 71359,
	"./card_91_wins_1.mp3": 11984,
	"./card_92_wins_1.mp3": 47229,
	"./card_93_wins_1.mp3": 73142,
	"./card_94_wins_1.mp3": 96059,
	"./card_95_wins_1.mp3": 56556,
	"./card_96_wins_1.mp3": 8953,
	"./card_97_wins_1.mp3": 3682,
	"./card_98_wins_1.mp3": 34263,
	"./card_99_wins_1.mp3": 81224,
	"./card_9_wins_1.mp3": 29821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93668;